<template>
	<div class="pageBox">
		<Header ref="Header" current='souye'></Header>
		<div class="pageBox_cen">
			<template v-for="(item,index) in list">
				<component :is="mapComponent[item.name]" :list='item' :ref="item.name" @goScroll='goScroll' />
			</template>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/header.vue"
	import Footer from "@/components/footer.vue"
	import mapComponent from "@/components/mapComponent.js";
	import {
		product_read
	} from "@/api/product.js"
	export default {
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				mapComponent,
				list: [{
						name: 'productDelBanner',
						value: '产品轮播图',
						list: [
							{
								img: require("@/assets/content/banner.png"),
								name: '智能辅助诊断系统',
								cen: '澳小宝',
							}, 
						]
					},
					{
						name:'productDelCen',
						value: '产品内容',
					}
				],
				navHidden: false, // 导航栏是否隐藏
				lastScrollTop: 0, // 上一次页面滚动的位置
				currentRoute:'',
				id:''
			}
		},
		mounted() {
			this.id=this.$route.query.id
			window.addEventListener('scroll', this.handleScroll);
			 this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
			this.$watch('$route', this.onRouteChange);
			let scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
			if(scrollTop==0){
				if(!this.$refs.Header.navHead){
					this.$refs.Header.headerHover = false;
				}
				this.$refs.Header.headerTrue = false;
			}else{
				this.$refs.Header.headerTrue = true;
				this.$refs.Header.headerHover = true;
			}
			this.getRead()
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
			
		},
		methods: {
			onRouteChange(newRoute, oldRoute) {
			  this.currentRoute = newRoute.path; // 更新当前路由地址
			  this.$refs.productDelCen[0].querValue = this.$route.query.value;
			  // this.goScroll(this.$route.query.value)
			},
			handleScroll() {
				const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
					.scrollTop || 0;
				if (currentScrollTop > this.lastScrollTop) {
					this.navHidden = true;
				} else {
					this.navHidden = false;
				}
				this.lastScrollTop = currentScrollTop;
	
				this.$refs.productDelCen[0].navHidden = this.navHidden;
				if(currentScrollTop==0){
					if(!this.$refs.Header.navHead){
						this.$refs.Header.headerHover = false;
					}
					this.$refs.Header.headerTrue = false;
				}else{
					this.$refs.Header.headerTrue = true;
					this.$refs.Header.headerHover = true;
				}
			},
			goScroll(e){
				this.lastScrollTop=e;
				// document.documentElement.scrollTop = e+10;
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
					element.scrollTop =e+10;
			},
			// 获取轮播图
			getRead(e) {
				let t = this;
				let data = {
					id: this.id
				}
			
				product_read(data).then((res) => {
					console.log(res)
					this.$nextTick(function() {
						t.$refs['productDelBanner'][0].setList(res.data.info.banners);
						t.$refs['productDelCen'][0].setInfo(res.data.info);
					})
				}).catch((err) => {
					console.log(err)
				})
			},
		},
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.pageBox {
		display: flex;
		flex-direction: column;
		min-height: 100vh;

		.pageBox_cen {
			flex: 1;
		}
	}
</style>